export default {
  failedActivationEmailResend: 'Problem resending activation email to selected user(s).',
  failedBillingPermissions: 'Only administrators with billing permissions can remove or add billing administrators.',
  failedToRemoveBilling: 'You must assign billing permissions to someone else before removing yourself as a billing administrator.',
  usersCouldNotBeDeleted: 'The user(s) could not be deleted.',
  userCouldNotBeSaved: 'An error occurred while trying to save the administrator',
  failedTotpMFAReset: 'Unable to reset TOTP MFA for the administrator',
};
